export default "__VITE_ASSET__CCey03HD__"